"use strict";

const { DateTime } = require("luxon");

/**
 * Get date for 'now'
 * If dateRangesReferenceDate is provided, use that instead;
 * this is mainly used for testing, for a deterministic computed date-range
 */
const getNow = (props) => {
  const { dateRangesReferenceDate, timezone } = props;

  if (dateRangesReferenceDate) {
    return DateTime.fromISO(dateRangesReferenceDate, {
      zone: timezone
    });
  }
  return DateTime.fromObject({ zone: timezone });
};

module.exports = getNow;
